module.exports = __webpack_public_path__ + "glyphicons-regular.03ab70cf5263ebec91a5.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.pro/glyphicons-regular.ttf
// module id = ../../../../../src/assets/css/fonts/glyphicons.pro/glyphicons-regular.ttf
// module chunks = 2